module.exports = __webpack_public_path__ + "images/feature/LU-124a64256d047e4b27de3997523d8359.gif";